class HttpInterceptor{

    static config($location, tokenService) {
      
        return {
            "request": (request) => {
                if (request.url.indexOf("/api/") > 0) {
                    request.headers = {
                        "Authorization": "Bearer " + tokenService.getAutheticatedUserToken(),
                        "Content-Type": !request.file ? "application/json" : request.headers['Content-Type'],
                        "Accept": "application/json"
                    };
                }

                return request;
            },
            "response": (response) => {
                return response;
            },
            "responseError": (response) => {
                return response;
            }
        }
    }
}

HttpInterceptor.config.$inject = ['$location', 'tokenService'];

export default HttpInterceptor;



// WEBPACK FOOTER //
// ./app/services/http-interceptor.service.js